import { KYMW1407Model } from '../kymw1407.model';
import { UpdateImageInfoEnabledModel } from '../../kymw1400/vo/update-image-info-enabled.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像情報を更新する。
 *
 * @export
 * @class UpdateImageInfoEnabledService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class UpdateImageInfoEnabledService extends PlessJsonResponderSub<any> {

  private vo: UpdateImageInfoEnabledModel = null;
  private model: KYMW1407Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateImageInfoEnabledService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageId: this.vo.imageId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1407Model} model
   * @param {UpdateImageInfoEnabledModel} vo
   * @memberof UpdateImageInfoEnabledService
   */
  execute(model: KYMW1407Model, vo: UpdateImageInfoEnabledModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14updateImageInfoEnabled', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof UpdateImageInfoEnabledService
   */
  success(_: any) {
    this.model.kymw1407Component.dispatcherGetImageListEvent();
  }
}
